import styled from '@emotion/styled';

export const LightGalleryContainer = styled.div`
  height: 100%;
  .lg-react-element {
    height: 100%;
  }
`;
